import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './met-canal-communication.reducer';

export const MetCanalCommunicationDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, []);

  const metCanalCommunicationEntity = useAppSelector(state => state.metCanalCommunication.entity);
  const updateSuccess = useAppSelector(state => state.metCanalCommunication.updateSuccess);

  const handleClose = () => {
    props.history.push('/met-canal-communication');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(metCanalCommunicationEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="metCanalCommunicationDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.metCanalCommunication.delete.question">
        <Translate
          contentKey="almobadaraMasterDataApp.metCanalCommunication.delete.question"
          interpolate={{ id: metCanalCommunicationEntity.id }}
        >
          Are you sure you want to delete this MetCanalCommunication?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-metCanalCommunication" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MetCanalCommunicationDeleteDialog;
